import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {
  public actionurl: string;
  public siteURL: string;
  public urlPath: boolean;
  //public setuserRole: boolean;
  //public currentRoute: string;
  public UserRole: string;
  //public userroleid: number;
  constructor() {
    this.urlPath = true;
    this.UserRole = '';
    this.siteURL = window.location.hostname;
    //this.actionurl = 'http://localhost:58400/';
    //this.actionurl = 'http://localhost:58419/';
    this.actionurl='https://perfectlearningapp.azurewebsites.net/';
  }
}
